export default "__VITE_ASSET__3jfMjYji__"